import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-photo-tips';

export default function Example() {
  return (
    <>
      <Head>
        <title>eBay Seller Photography Guide To Get Your Listings Noticed</title>
        <meta
          name='description'
          content='Learn how to make your photos pop and get potential buyers to take notice of your listings at first glance. Level up your photography game with these practical and useful seller photo tips.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-photo-tips' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-photo-tips' />
        <meta property='og:title' content='eBay Seller Photography Guide To Get Your Listings Noticed' />
        <meta
          property='og:description'
          content='Learn how to make your photos pop and get potential buyers to take notice of your listings at first glance. Level up your photography game with these practical and useful seller photo tips.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
